export default {
  appStoreUrl: "https://apps.apple.com/us/app/finalbooks-accounting/id1410685456?ls=1",
  playStoreUrl: "https://play.google.com/store/apps/details?id=com.finalbooks.app",
  appDownloadmessage: "Manage your business from anywhere, anytime by using FinalBooks Mobile Apps. Download it today.",
  whatsappNoti: "Connect your WhatsApp account and send notifications to your clients. Send Invoices, Payment Reminders, Payment Outstanding and Payment Thank you messages to your clients.",
}
